import React from "react";
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import { Field, reduxForm } from "redux-form";

import { DropdownListField } from "../common/Inputs";
import * as fetchingState from '../../constants/fetchingState';

let Filter = class extends React.Component {
    render() {
        const { categories, isActiveStates, categoriesFetching } = this.props;
        return (
            <Grid fluid={true} >
                <Row>
                    <Col lg={12}>
                        <Panel>
                            <Panel.Heading>Фильтр</Panel.Heading>
                            <Panel.Body>
                                {categoriesFetching === fetchingState.FETCHING &&
                                    <span>Загрузка списка категорий...</span>}

                                {categoriesFetching === fetchingState.FAILED &&
                                    <span>Ошибка загрузки списка категорий...</span>}
                                {categoriesFetching === fetchingState.FETCHED &&
                                    <form className='form-horizontal' style={{ display: 'flex' }} >
                                        <Field
                                            name='category'
                                            component={DropdownListField}
                                            data={categories}
                                            valueField='Id'
                                            textField='Name'
                                            label='Категория' />
                                        <Field
                                            name='isActive'
                                            component={DropdownListField}
                                            data={isActiveStates}
                                            valueField='Value'
                                            textField='Name'
                                            label='Активна?' />
                                    </form>}
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </Grid >
        )
    }
}

Filter = reduxForm({
    form: 'serviceFilter',
})(Filter);

export default Filter;


// WEBPACK FOOTER //
// ./src/components/services/Filter.jsx